import React from 'react';
import ShipmentBasicInfoComponent from './shipment-basic-info.component';
import ShipmentItemInfoComponent from './shipment-item-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import AgentTrackerComponent from './shipment-agent-track.component';


export const ShipmentComponent = ({ orderStatus, rowData, columnDefs, selectShipping, getTransportersName, handleInnerFormChange, transportAgents, back, location }: any) => {
  const tabItems = [
    {
      id: 1,
      title: 'Basic Info',
      component: <ShipmentBasicInfoComponent
        selectShipping={selectShipping}
        orderStatus={orderStatus}
        handleInnerFormChange={handleInnerFormChange}
        transportAgents={transportAgents} />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Order Info',
      component: <ShipmentItemInfoComponent
        columnDefs={columnDefs}
        rowData={rowData}
      />,
      isVisible: true,
    },
    // {
    //   id: 3,
    //   title: 'Agent tracker Info',
    //   component: <AgentTrackerComponent
    //     selectShipping={selectShipping}
    //     location={location}
    //   />,
    //   isVisible: true,
    // },
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end h-20'>
        <button
          onClick={back}
          type='button'
          className="m-2 bg-primary text-light rounded font-medium px-4 py-3 "
        >
          Back
        </button>
        {/* <button
           className="m-2 bg-primary text-light rounded font-medium px-4 py-3 "
           onClick={handleFormSubmit}
 
           type="submit"
         >
           Save
         </button> */}
      </div>
    </div>
  )
}
export default ShipmentComponent;